<template>
  <div>
    <evento-selecionado-comentario-dialog
      :is-dialog-open.sync="isEditarComentarioDialogOpen"
      :ticket-agendamento-id="ticketAgendamentoId"
      :comentario-selecionado="comentarioSelecionado"
      @refetch-data="$emit('refetch-data')"
    />

    <v-timeline :dense="$vuetify.breakpoint.smAndDown">
      <v-timeline-item
        v-for="(comentario, index) in timelineComentarios"
        :key="index"
        small
        fill-dot
        :left="comentario.left"
        :right="comentario.right"
      >
        <template #opposite>
          <span>{{ functions.converterDateTimeStringEmLocaleDateTimeString(comentario.dataCadastro) }}</span>
        </template>

        <v-hover
          v-slot="{ hover }"
          open-delay="50"
        >
          <v-card
            hover
            :elevation="hover ? 12 : 2"
            :class="`
              d-flex
              flex-column
              ${hover ? 'on-hover' : ''}
              ${$vuetify.breakpoint.mdAndUp && comentario.left ? 'text-right' : 'text-left'}
            `"
            @click.native="selecionarComentario(comentario)"
          >
            <v-card-title
              :class="`
              d-flex
              ${$vuetify.breakpoint.mdAndUp && comentario.left ? 'justify-end' : 'justify-start'}
            `"
            >
              {{ comentario.pessoaNome }}
            </v-card-title>

            <v-card-text>
              {{ comentario.comentario }}
            </v-card-text>
          </v-card>
        </v-hover>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import EventoSelecionadoComentarioDialog from './EventoSelecionadoComentarioDialog.vue'
import { converterDateTimeStringEmLocaleDateTimeString } from '@/utils/dateTime'

export default {
  emits: ['refetch-data'],

  components: {
    EventoSelecionadoComentarioDialog,
  },

  props: {
    ticketAgendamentoId: {
      type: Number,
      required: true,
    },
    timelineComentarios: {
      type: Array,
      required: true,
    },
  },

  setup() {
    const isEditarComentarioDialogOpen = ref(false)

    const comentarioSelecionado = ref(null)

    function selecionarComentario(comentario) {
      isEditarComentarioDialogOpen.value = true
      comentarioSelecionado.value = JSON.parse(JSON.stringify(comentario))
    }

    return {
      isEditarComentarioDialogOpen,
      comentarioSelecionado,
      selecionarComentario,
      functions: {
        converterDateTimeStringEmLocaleDateTimeString,
      },
    }
  },
}
</script>
